export enum ProfileType {
    ORIGINAL = 'ORIGINAL',
    COPIED = 'COPIED',
    NONE = 'NONE',
    OUTLOOK = 'OUTLOOK'
}
